<template>
  <div class="container-fluid">
    <help :portal="portal" class="pull-right padding-80" />
    <h4 class="heading">Resume Draft</h4>
    <p>Please enter your e-mail address and request number to resume a request.</p>
    <form>
      <div class="form-group">
        <label for="email" class="control-label">Email Address</label>
        <input id="email" v-model="email" type="email" class="form-control" @blur="$v.email.$touch()" />
        <div v-if="!$v.email.email && $v.email.$error" class="text-danger">Please enter a valid email address</div>
        <div v-if="!$v.email.required && $v.email.$error" class="text-danger">Please enter email address</div>
        <div v-if="!$v.email.maxLength && $v.email.$error" class="text-danger">Allowed upto 150 characters only</div>
      </div>
      <div class="form-group">
        <label for="requestNumber" class="control-label">Request Number</label>
        <input id="requestNumber" v-model="requestNumber" type="text" class="form-control" />
        <div v-if="!$v.requestNumber.required && $v.requestNumber.$error" class="text-danger">
          Request number cannot be empty
        </div>
      </div>
      <div class="form-group"><p v-if="invalidData" class="text-danger">Email or Reference Number not found.</p></div>
      <div class="form-group">
        <button class="btn btn-sm btn-default" style="margin-right:1%;" @click="cancelDraftEvent($event)">
          Cancel
        </button>
        <button class="btn btn-sm btn-primary" @click="resumeDraft($event)">Submit</button>
      </div>
      <!-- loader -->
      <spinner ref="spinner" v-model="showSpinner" fixed size="lg" text="" />
      <a href="#" @click="forgotPassword">Forgot your Request Number?</a>
    </form>
  </div>
</template>
<script>
import help from "@/mycfm/components/HelpInfo";
import { email, required, maxLength } from "vuelidate/lib/validators";
import spinner from "build-ui-x/src/Spinner";
import { Mro } from "@/model/Mro";
import { resumeDraftCompany } from "@/services/endpointsService";
import { Product } from "@/model/Product";
import { Company } from "@/model/Company";

export default {
  components: {
    help,
    spinner
  },
  props: {
    portal: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      email: "",
      requestNumber: "",
      invalidData: false,
      showSpinner: false
    };
  },
  beforeMount() {
    if (this.$route.query.email) {
      this.email = this.$route.query.email;
    }
    if (this.$route.query.referenceNumber) {
      this.requestNumber = this.$route.query.referenceNumber;
    }
  },
  validations: {
    email: {
      email,
      required,
      maxLength: maxLength(150)
    },
    requestNumber: {
      required
    }
  },
  methods: {
    cancelDraftEvent(e) {
      e.preventDefault();
      this.$router.push("/");
    },
    resumeDraft(e) {
      e.preventDefault();
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      const config = {
        params: {
          email: this.email,
          aobReferenceNumber: this.requestNumber
        }
      };

      this.showSpinner = true;
      resumeDraftCompany(config)
        .then(data => {
          if (!data) {
            this.invalidData = true;
            return;
          }
          this.invalidData = false;

          let { productTypes, company, userDetails, productMRO, aobRefNumber } = data.companyRegistrationSavedData;

          // function to replace null values to empty string recursively
          // this is required because resumeDraft service is sending "" as null value
          // but we are expecting null as ""
          function changeNullValues(obj) {
            for (let key in obj) {
              if (typeof obj[key] === "object" && obj[key] !== null) {
                obj[key] = changeNullValues(obj[key]);
              } else if (obj[key] === null) {
                obj[key] = "";
              }
            }
            return obj;
          }
          // change null to empty string in productTypes
          productTypes = productTypes.map(function(product) {
            product = changeNullValues(product);

            if (product.productInfo === "") {
              product.productInfo = null;
            }

            return product;
          });

          // replace null values to ""
          company = changeNullValues(company);
          // expected null if empty
          if (company.nameChangeDate === "") {
            company.nameChangeDate = null;
          }
          // replace null values to ""
          userDetails = changeNullValues(userDetails);

          if (userDetails.greenCard === "") {
            userDetails.greenCard = "No";
          }
          // adding company details
          this.$store.dispatch("company/addNewCompany", company);

          // push company doc to S3Doc store also if it's there
          if(company.companyDocuments != null) {
            for (let i = 0; i < company.companyDocuments.length; i++) {
              this.$store.dispatch("s3Docs/addDoc", company.companyDocuments[i]);
            }
          }

          // adding user details
          this.$store.dispatch("companyUser/addUserDetails", userDetails);
          // setting reference number
          this.$store.dispatch("product/setReferenceNumber", aobRefNumber);

          // add mro details
          if (productMRO != null) {
            productMRO = changeNullValues(productMRO);
            if (productMRO.documents == "") {
              productMRO.documents = [];
            }
            if (productMRO.engineDetails !== undefined) {
              let mro = {
                servicesMRO: productMRO.servicesMRO,
                reqMroDetailsChanged: productMRO.reqMroDetailsChanged,
                modificationToRenewedAgreement: productMRO.modificationToRenewedAgreement,
                engineDetails: productMRO.engineDetails,
                documents: productMRO.documents
              };
              this.$store.dispatch("mro/addNewMRO", new Mro(mro));
            } else {
              let mro = {
                servicesMRO: productMRO.servicesMRO,
                reqMroDetailsChanged: productMRO.reqMroDetailsChanged,
                modificationToRenewedAgreement: productMRO.modificationToRenewedAgreement,
                documents: productMRO.documents
              };
              this.$store.dispatch("mro/addNewMRO", new Mro(mro));
            }
            // iterate over productMRO.documents and push them to S3Doc store also
            if (productMRO.documents != null) {
              for (let i = 0; i < productMRO.documents.length; i++) {
                this.$store.dispatch("s3Docs/addDoc", productMRO.documents[i]);
              }
            }
          }

          for (let i = 0; i < productTypes.length; i++) {
            let companyDetails = {
              companyTypeId: productTypes[i].companyDetails.companyTypeId,
              companyTypeDesc: productTypes[i].companyDetails.companyTypeDesc,
              companyOtherName: productTypes[i].companyDetails.companyOtherName,
              mroNeededBenefits: productTypes[i].companyDetails.mroNeededBenefits
            };

            let prodInfo = {
              productTypeId: productTypes[i].productTypeId,
              productTypeDesc: productTypes[i].productTypeDesc,
              companyDetails: new Company(companyDetails),
              productInfo: productTypes[i].productInfo
            };

            // iterate over productTypes[i].productInfo.documents and push them to S3Doc store also
            if (prodInfo.productInfo != null && prodInfo.productInfo.documents != null) {
              let prodDocLength = prodInfo.productInfo.documents.length;
              let prodDocs = prodInfo.productInfo.documents;
              for (let j = 0; j < prodDocLength; j++) {
                this.$store.dispatch("s3Docs/addDoc", prodDocs[j]);
              }
            }
            this.$store.dispatch("product/setNewProduct", new Product(prodInfo));
          }

          sessionStorage.setItem("company-user-email", userDetails.email);

          this.$store.dispatch("user/setEmail", userDetails.email);
          this.$store.dispatch("companyUser/setEmail", userDetails.email);

          this.$router.push("company-registration");
        })
        .catch(() => {})
        .finally(() => {
          // hide spinner
          this.showSpinner = false;
        });
    },
    forgotPassword(e) {
      e.preventDefault();
      this.$router.push("/forgot-password");
    }
  }
};
</script>
<style lang="less" scoped>
input {
  width: 250px;
}
</style>
